export const LAW_FIRM_PRESET = {
    label: 'Law Firm',
    keys: {
        project: 'Matter',
        projects: 'Matters',
        existingProject: 'Matter',
        existingProjects: 'Matters',
        potentialProject: 'Opportunity',
        potentialProjects: 'Opportunities',
        serviceLine: 'Practice Area',
        serviceLines: 'Practice Areas',
        projectTypeGroup: 'Practice Group',
        projectType: 'Matter Type',
        projectTypes: 'Matter Types',
        revenue: 'Billings',
        revenueAtRisk: 'Billings at Risk',
        t12Revenue: '12-Month Billings',
        tXRevenue: '#{month}-Month Billings',
        revenueTD: 'Billings TD',
        averageRevenue: 'Average Billings',
        averageRevenueSize: 'Average Billing Size',
        firmGrowthPotential: 'Firm BD Potential',
        growthPotential: 'BD Potential',
        parentCrm: 'Relationship Partner',
        parentCrms: 'Relationship Partners',
        parentCustomerRelationsManager: 'Client Relationship Partner',
        parentCustomerRelationsManagers: 'Client Relationship Partners',
        subCrm: 'Billing Partner',
        subCrms: 'Billing Partners',
        subCustomerRelationsManager: 'Billing Partner',
        subCustomerRelationsManagers: 'Billing Partners',
        hoursBilled: 'Hours Billed',
        allFirm: 'All Firm',
        myProjects: 'My Matters',
        projectPIC: 'Partner in Charge',
        projectPersonInCharge: 'Partner in Charge',
        cm: 'RP',
        projectCRMs: 'Project Relationship Partners',
    },
    tooltipReplacements: [
        { from: 'Project', to: 'Matter' },
        { from: 'projects', to: 'matters' },
        { from: 'Revenue', to: 'Billings' },
        { from: 'revenue', to: 'billings' },
        { from: 'Service Line', to: 'Practice Area' },
        { from: 'Service Lines', to: 'Practice Areas' },
    ],
};
